import { CrossClientQueryResultSource } from '../../../../models/CrossClient'
import React from 'react'
import { formatDate } from '../../../../apps/professional-app/fa/common/aifeatures/utils'
import { CrossClientResultSourceIcon } from './CrossClientResultSourceIcon'
import { getCrossClientResultSourceLabel } from './utils'

export interface CrossClientResultSourceProps {
  resultSource: CrossClientQueryResultSource
}

export const CrossClientResultSource: React.FC<CrossClientResultSourceProps> = ({ resultSource }) => {
  const retrievedAt = resultSource.retrievedAt ? formatDate(resultSource.retrievedAt) : null

  return (
    <div className='d-flex gap-3 paragraph-small ms-1 ps-3'>
      <div className='d-flex gap-1 align-items-center'>
        <CrossClientResultSourceIcon source={resultSource.source} />
        <span>{getCrossClientResultSourceLabel(resultSource.source)}</span>
      </div>
      {retrievedAt ? (
        <div className='d-flex gap-1 align-items-center'>
          <i className='bi bi-calendar' />
          {retrievedAt}
        </div>
      ) : null}
    </div>
  )
}
